<template>
    <div class="container-fluid" style="margin-block: 30px">
        <div class="row">
            <div class="col">
                <a-spin :spinning="loading">
                    <card class="shadow" header-classes="bg-transparent" style="min-height: 480px">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">Sales Dashboard</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <base-input label="Date">
                                    <!-- <a-range-picker class="w-100" v-model="filters.date_range"
                                        :disabledDate="disabledDate" :valueFormat="dateFormat" /> -->
                                    <a-month-picker class="w-100" v-model="filters.month" :disabledDate="disabledDate" valueFormat="YYYY-MM"/>
                                </base-input>
                            </div>
                            <div class="col">
                                <base-input label="Store Company">
                                    <a-select class="w-100" v-model="filters.company_id">
                                        <a-select-option key=0 value=0>All</a-select-option>
                                        <a-select-option v-for="company in companies" :key="company.id"
                                            :value="company.id">
                                            {{ company.name }}
                                        </a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                            <div class="col">
                                <base-input label="Store Ownership">
                                    <a-select class="w-100" v-model="filters.ownership_type">
                                        <a-select-option value="all">All</a-select-option>
                                        <a-select-option value="owned">Owned</a-select-option>
                                        <a-select-option value="franchise">Franchise</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                            <div class="col-2 my-auto">
                                <a-button class="w-100" style="margin-top: 4px" type="primary" @click="filterQuery">
                                    Apply Filter
                                </a-button>
                            </div>
                        </div>
                        <hr class="mt-1">
                        <div class="row w-100 mx-0">
                            <a-table class="w-100" bordered :columns="salesColumns" :dataSource="totalSales" :scroll="{ x: true }" :loading="loading" :pagination=false >
                            </a-table>
                        </div>
                        <!-- <div class="row w-100 mx-0">
                            <a-table class="w-100" bordered :columns="mtdColumns" :dataSource="totalSales" :scroll="{ x: true }" :loading="loading" :pagination=false ></a-table>
                        </div> -->
                    </card>
                </a-spin>
            </div>
        </div>
    </div>

</template>

<script>
import {
    mapState,
    // mapActions
} from 'vuex'
import moment from 'moment';
import HTTPRequest from '../../controllers/httpRequest';

// formats number to proper currency format
var formatPeso = new Intl.NumberFormat('en-PH', {
    // style: 'currency',
    // currency: 'PHP'
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export default {
    computed: {
        ...mapState(['loggedIn', 'endPoint', 'serverType']),
    },
    data () {
        return {
            dateFormat: 'YYYY-MM-DD',
            loading: true,
            filters: {
                date_range: [
                    moment().subtract(7, 'days').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD')
                ],
                month: moment().format('YYYY-MM'),
                company_id: '0',
                ownership_type: 'all',
            },
            companies: [],
            totalSales: [],
            salesColumns: [],
            mtdColumns: [],
            selectedCompanies: [],
            selectedOwnershipType: 'all'
        }
    },
    mounted: async function () {
        setTimeout(() => {
            this.loading = false
        }, 10000);
        let companyList = await HTTPRequest.getRequest(this.endPoint + "companies", null)
        if (companyList != undefined)
            this.companies = companyList.data

        // let salesData = await HTTPRequest.getRequest(this.endPoint + `pos_documents/total_sales?date_from=${this.filters.date_range[0]}&date_to=${this.filters.date_range[1]}`, null)
        let salesData = await HTTPRequest.getRequest(this.endPoint + `pos_documents/total_sales?month=${this.filters.month}`, null)

        this.parseData(salesData)

        this.loading = false
    },
    methods: {
        moment,
        disabledDate (current) {
            return current && current > moment().endOf('day');
        },
        async filterQuery () {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 10000);

            // let [start, end] = this.filters.date_range
            // let query = `?date_from=${start}&date_to=${end}`
            let query = `?month=${this.filters.month}`

            if (this.filters.company_id !== '0') {
                query += `&company_id=${this.filters.company_id}`
            }

            if (this.filters.ownership_type !== 'all') {
                query += `&ownership_type=${this.filters.ownership_type}`
            }
            this.selectedOwnershipType = this.filters.ownership_type

            let salesData = await HTTPRequest.getRequest(this.endPoint + "pos_documents/total_sales" + query, null)

            this.parseData(salesData)

            this.loading = false
        },
        parseData (data) {
            this.salesColumns = [
                {
                    title: <h3>Total Sales</h3>,
                    dataIndex: "company_id",
                    align: "center",
                    width: 160,
                    fixed: true,
                    colSpan: 2,
                    customRender: (value, row, index) => {
                        const obj = {
                            children: this.fetchCompanyName(value),
                            attrs: {},
                        };
                        let modCheck = this.selectedOwnershipType === 'all' ? 3 : 2

                        if (index % modCheck == 0) {
                            obj.attrs.rowSpan = modCheck
                        } else {
                            obj.attrs.rowSpan = 0
                        }
                        
                        if (row["ownership_type"] === 'grand total') {
                            obj.attrs.colSpan = 0
                        }
                        return obj;
                    }
                },
                {
                    title: null,
                    dataIndex: "ownership_type",
                    align: "center",
                    width: 120,
                    fixed: true,
                    colSpan: 0,
                    customRender: (value, row) => {
                        let valueText = 
                            value == 'total' || value == 'grand total' ?
                            <b>{ _.startCase(value) }</b> :
                            _.capitalize(value)

                        const obj = {
                            children: valueText,
                            attrs: {},
                        };

                        if (row["ownership_type"] === 'grand total') {
                            obj.attrs.colSpan = 2
                        }

                        return obj
                    }
                },
                {
                    title: <b>MTD Sales</b>,
                    dataIndex: 'mtd_sales',
                    align: 'right',
                    width: 160,
                    fixed: 'right',
                    customRender: (value, row) => {
                        let valueText = this.pesofy(value)

                        return ((row["ownership_type"] === 'total') || (row["ownership_type"] === 'grand total') ?
                            <b>{ valueText }</b> :
                            valueText
                        )
                    }
                },
                {
                    title: <b>MTD ADS</b>,
                    dataIndex: 'ads',
                    align: 'right',
                    width: 160,
                    fixed: 'right',
                    customRender: (value, row) => {
                        let valueText = this.pesofy(value)

                        return ((row["ownership_type"] === 'total') || (row["ownership_type"] === 'grand total') ?
                            <b>{ valueText }</b> :
                            valueText
                        )
                    }
                }
            ]

            this.selectedCompanies = []
            if (this.filters.company_id !== '0') {
                this.selectedCompanies.push(this.filters.company_id)
            } else {
                this.companies.forEach(company => this.selectedCompanies.push(company.id))
            }

            let tableData = []

            // create rows for data
            this.selectedCompanies.forEach(company => {
                if (this.selectedOwnershipType !== 'all') {
                    tableData.push(
                        {
                            key: `${company}-${this.selectedOwnershipType}`,
                            company_id: company,
                            ownership_type: this.selectedOwnershipType
                        },
                        {
                            key: `${company}-total`,
                            company_id: company,
                            ownership_type: "total"
                        }
                    )
                } else {
                    tableData.push(
                        {
                            key: `${company}-owned`,
                            company_id: company,
                            ownership_type: "owned"
                        },
                        {
                            key: `${company}-franchise`,
                            company_id: company,
                            ownership_type: "franchise"
                        },
                        {
                            key: `${company}-total`,
                            company_id: company,
                            ownership_type: "total"
                        },
                    )
                }
            })
            
            // let [loop, end] = this.filters.date_range;
            let loop = this.filters.month + '-01',
                end = moment(loop).endOf('month').format('YYYY-MM-DD')

            // dynamically create columns per day
            while (loop <= end) {
                this.salesColumns.splice(-2, 0, {
                    title: <b>{ loop }<br/>{ moment(loop).format('dddd') }</b>,
                    dataIndex: `daily-${loop}`,
                    width: 160,
                    align: 'right',
                    customRender: (value, row) => {
                        let valueText = this.pesofy(value)

                        return ((row["ownership_type"] === 'total') || (row["ownership_type"] === 'grand total') ?
                            <b>{ valueText }</b> :
                            valueText
                        )
                    }
                })

                let newDate = moment(loop).add(1, 'day').format("YYYY-MM-DD")
                loop = newDate;
            }

            // putting daily sales data in table
            data.data.forEach(dataEntry => {
                let index = tableData.findIndex(row => row.key === `${dataEntry.company_id}-${dataEntry.ownership_type}`)
                tableData[index][`daily-${dataEntry.business_date}`] = parseFloat(dataEntry.daily_sales)
            })

            // computing total per day
            let columns = Object.keys(tableData[0])
            columns.splice(0, 3)

            let allOperatingDays = []

            this.selectedCompanies.forEach(company => {
                let ownedIndex, franchiseIndex, totalIndex
                let op_owned = [], op_franchise = []

                tableData.forEach((row, index) => {
                    if (row.company_id === company && row.ownership_type == 'owned') {
                        ownedIndex = index
                    } else if (row.company_id === company && row.ownership_type == 'franchise') {
                        franchiseIndex = index
                    } else if (row.company_id === company && row.ownership_type == 'total') {
                        totalIndex = index
                    }
                })

                columns.forEach(column => {
                    if (ownedIndex === undefined) {
                        tableData[totalIndex][column] = tableData[franchiseIndex][column]
                    } else if (franchiseIndex === undefined) {
                        tableData[totalIndex][column] = tableData[ownedIndex][column]
                    } else {
                        tableData[totalIndex][column] = tableData[ownedIndex][column] + tableData[franchiseIndex][column]
                    }
                })

                if (ownedIndex === undefined) {
                    tableData[totalIndex]["mtd_sales"] = tableData[franchiseIndex]["mtd_sales"]
                } else if (franchiseIndex === undefined) {
                    tableData[totalIndex]["mtd_sales"] = tableData[ownedIndex]["mtd_sales"]
                } else {
                    tableData[totalIndex]["mtd_sales"] = tableData[ownedIndex]["mtd_sales"] + tableData[franchiseIndex]["mtd_sales"]
                }

                tableData.forEach(row => {
                    let mtd = 0

                    columns.forEach(column => {
                        mtd += row[column]
                        if (row[column] > 0)
                            if (row["ownership_type"] == 'owned')
                                op_owned.push(column)
                            else if (row["ownership_type"] == 'franchise')
                                op_franchise.push(column)
                    })

                    row["mtd_sales"] = mtd
                    if (row["ownership_type"] == 'owned')
                        row["ads"] = mtd / op_owned.length || 0
                    else if (row["ownership_type"] == 'franchise')
                        row["ads"] = mtd / op_franchise.length || 0
                    else {
                        let union = [...new Set([...op_owned, ...op_franchise])]
                        allOperatingDays.push(union)

                        row["ads"] = mtd / union.length || 0
                    }
                })
            })

            if (this.filters.company_id == '0') {
                tableData.push({
                    key: "grand-total",
                    ownership_type: "grand total"
                })

                let total_index = tableData.reduce((r, v, i) => r.concat(v.ownership_type === 'total' ? i : []), []);

                let grand_index = tableData.length - 1

                columns.push("mtd_sales")
                columns.forEach(column => {
                    let grand = 0
                    total_index.forEach(index =>{
                        grand += tableData[index][column]
                    })
                    tableData[grand_index][column] = grand
                })

                let op_allCompanies = []
                
                allOperatingDays.forEach(company => {
                    op_allCompanies = [...new Set([...op_allCompanies, ...company])]
                })

                tableData[grand_index]["ads"] = tableData[grand_index]["mtd_sales"] / op_allCompanies.length || 0
            }

            this.totalSales = tableData
        },
        fetchCompanyName (id) {
            if (id) {
                let index = this.companies.findIndex(company => company.id === id)
                return <b>{ this.companies[index].name }</b>
            }
            return null
        },
        pesofy (value) {
            return formatPeso.format(value)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>